<template lang="pug">
  .part.part-5
    .game__title
      p 你正在為了什麼心跳加速?
    ul.game__cards
      li.game__cards__card(
        v-for="item, index in cards"
        :class="[`game__cards__card--${item.className}`, {'game__cards__card--choosed': index === choosedIndex}]"
      )
        a(href="#" @click.prevent="chooseCard(index)")
          span {{ item.cardName }}
    a.game__button.game__button--next(
      :class="{'game__button--disabled': choosedIndex === null}"
      href="#"
      @click.prevent="check"
    )
      span 確認送出
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'GamePart5',
  props: {
    changePart: Function,
  },
  data: () => {
    return {
      cards: [
        {
          className: 'job',
          cardName: '工作',
        },
        {
          className: 'learning',
          cardName: '課業',
        },
        {
          className: 'love',
          cardName: '感情',
        },
        {
          className: 'sport',
          cardName: '運動',
        },
      ],
      choosedIndex: null
    }
  },
  computed: {
    ...mapState(['author'])
  },
  methods: {
    ...mapActions(['toggleParticlesWave', 'saveAuthor']),
    chooseCard(index) {
      if (this.choosedIndex === index) {
        this.choosedIndex = null
      } else {
        this.choosedIndex = index;
        let label = '';
        switch(index) {
          case 0:
            label = 'work';
            break;
          case 1:
            label = 'school';
            break;
          case 2:
            label = 'love';
            break;
          case 3:
            label = 'sport';
            break;
        }
        this.$trackEvent('step3', 'click_button', `step3_${label}`);
      }
    },
    check() {
      const { author, changePart, toggleParticlesWave, choosedIndex, saveAuthor } = this;
      if (choosedIndex === null) {
        this.$toast.error('請選擇你正在為了什麼心跳加速?');
        return;
      }
      const type = (choosedIndex === 0) ? 1 : (choosedIndex === 1) ? 4 : (choosedIndex === 2) ? 2 : 3;
      saveAuthor({...author, type}) // 1工作, 2感情, 3運動, 4課業
      changePart(6);
      toggleParticlesWave(true);
      this.$trackEvent('step3', 'click_button', 'step3_next');
    },
  },
  mounted() {
    this.$trackPage('step3');
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/game/part-5/';

#game .part-5 {

  .game__title {
    position: absolute;
    top: vw(585);
    left: 0;
    width: 100%;
    p {
      font-size: vw(30);
      text-align: center;
      line-height: 1;
      letter-spacing: vw(letterSpacing(500, 30));
      padding-left: vw(letterSpacing(500, 30));
      @include narrow-text;
      @include neon-text;
    }
  }

  .game__cards {
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: vw(664);
    left: 0;
    width: 100%;
  }

  .game__cards__card {
    margin: 0 vw(10.5);
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: vw(145);
      height: vw(223);
      background-image: url($assets + 'cards.png');
      background-repeat: no-repeat;
      background-size: vw(592) vw(223);
      box-shadow: rgba(#fff, 0.5) inset 0 0 vw(30), rgba(#ff47bc, 0.5) 0 0 vw(15), rgba(#ff47bc, 0.3) 0 0 vw(25);
      border-radius: vw(10);
      overflow: hidden;
      transition: box-shadow .5s ease;
    }
    &--job a { background-position: vw(0) 0; }
    &--learning a { background-position: vw(-148) 0; }
    &--love a { background-position: vw(-148 * 2) 0; }
    &--sport a { background-position: vw(-148 * 3) 0; }
    &--choosed a {
      box-shadow:
        rgba(#fff, 1) inset 0 0 vw(30),
        rgba(#ff47bc, 1) 0 0 vw(15),
        rgba(#ff47bc, 1) 0 0 vw(25),
        rgba(#ff47bc, 0.8) 0 0 vw(35);
    }
    span {
      color: #fff;
      font-weight: 500;
      text-align: center;
      line-height: 1;
      letter-spacing: vw(letterSpacing(500, 30));
      padding-left: vw(letterSpacing(500, 30));
      @include narrow-text;
      text-shadow:
        rgba(#9a1623, 1) 0 0 .15em,
        rgba(#9a1623, 1) 0 0 .25em,
        rgba(#9a1623, 1) 0 0 .35em,
        rgba(#9a1623, 1) 0 0 .45em,
        rgba(#9a1623, 1) 0 0 .55em,
        rgba(#9a1623, 1) 0 0 .65em;
    }
  }

  .game__button--next {
    top: vw(1018);
    left: vw(156);
    transition: opacity .5s ease;
  }

  .game__button--disabled {
    pointer-events: none;
    opacity: 0.5;
  }

}

</style>
